
import { supabase } from "@/integrations/supabase/client";

let pageStartTime: number;

export const trackPageVisit = async (path: string) => {
  console.log(`Tracking page visit: ${path}`);
  try {
    // Calculate duration in seconds
    const durationSeconds = Math.round((Date.now() - pageStartTime) / 1000);
    
    // Get referrer if available
    const referrer = document?.referrer || null;
    
    // Get user agent
    const userAgent = navigator?.userAgent || null;
    
    // Current time in ISO format for created_at
    const currentTime = new Date().toISOString();

    await supabase
      .from('page_visits')
      .insert({
        page_path: path,
        referrer,
        user_agent: userAgent,
        duration_seconds: durationSeconds,
        created_at: currentTime
      });

  } catch (error) {
    console.error("Error tracking page visit:", error);
  }
};

export const startPageTracking = () => {
  console.log("Page tracking initialized");
  pageStartTime = Date.now();
};
